import { useAuth } from "../context/AuthContext";

/**
 * What the signed-in user may do on one module, for gating buttons:
 *
 *   const can = usePerm("PACKING_SLIP");
 *   {can.create && <Btn>New</Btn>}
 *   {can.export && <Btn>Excel</Btn>}   // Excel needs the Export tick
 *   {can.print && <Btn>PDF</Btn>}      // PDF / print needs the Print tick
 *
 * Mirrors the backend guards: CREATE for new records, EDIT for changes and
 * status moves (confirm / cancel / send), DELETE for delete, APPROVE for
 * approvals, EXPORT for Excel, PRINT for PDF and printing. Owners pass all.
 */
export default function usePerm(module) {
  const { hasPermission } = useAuth();
  return {
    view: hasPermission(module, "VIEW"),
    create: hasPermission(module, "CREATE"),
    edit: hasPermission(module, "EDIT"),
    del: hasPermission(module, "DELETE"),
    approve: hasPermission(module, "APPROVE"),
    export: hasPermission(module, "EXPORT"),
    print: hasPermission(module, "PRINT"),
  };
}
